<ion-menu class="ion-left-side-menu" contentId="main-content" side="start" swipeGesture="false" (ionWillOpen)="init()">
  <ion-header>
    <ion-item>
      <ion-avatar slot="start">
        <img alt="" [src]="user?.avatarUrl ? user.avatarUrl : 'assets/images/user.webp'" />
      </ion-avatar>
      <ion-label>
        <h2>{{ fullName }}</h2>
        @if (!isAnonymous) {
          <p class="user-mobile">
            {{ userProfileService.userProfile?.mobile }}
          </p>
        }
      </ion-label>
    </ion-item>
  </ion-header>
  <ion-content>
    <ion-list class="list-left-side-menu">
      <ion-menu-toggle>
        <ion-item menuClose mode="md" tappable data-cy="home-item" (click)="$event.preventDefault(); goHome()">
          <ion-icon slot="start" src="assets/icon/Inicio.svg" />
          <ion-label>{{ 'Home' | uvetranslate }}</ion-label>
        </ion-item>
      </ion-menu-toggle>

      @if (!isAnonymous && !isSingleSignOnMode) {
        <ion-menu-toggle>
          <ion-item menuClose mode="md" data-cy="profile-item" tappable (click)="goToProfile($event)">
            <ion-icon slot="start" src="assets/icon/profile_img.svg" />
            <ion-label>{{ 'profile' | uvetranslate }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      }

      <ion-menu-toggle>
        @if (showPrivacyURL || showBlockAndArchive) {
          <ion-item menuClose mode="md" data-cy="setting-item" tappable (click)="goToSetings($event)">
            <ion-icon slot="start" src="assets/icon/settings.svg" />
            <ion-label>{{ 'setting' | translate }}</ion-label>
          </ion-item>
        }
      </ion-menu-toggle>

      @if (howToUseAppActive) {
        <ion-menu-toggle>
          <ion-item class="correct-ion-icon-position" menuClose mode="md" tappable (click)="goToAppUsageHelper($event)">
            <ion-icon class="correct-ion-icon-size" name="help-circle-outline" slot="start" />
            <ion-label>{{ 'how_to_use_app' | uvetranslate }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      }

      @if (!isAnonymous && !isSingleSignOnMode) {
        <ion-menu-toggle>
          <ion-item menuClose mode="md" data-cy="logout-item" tappable (click)="logoutConfirmation()">
            <ion-icon slot="start" src="assets/icon/logout.svg" />
            <ion-label>{{ 'logout' | uvetranslate }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      }

      @if (isAnonymous && !hideSignUp) {
        <ion-menu-toggle>
          <ion-item menuClose mode="md" tappable (click)="goToSignupAnonymous($event)">
            <ion-icon id="icon-margin" name="person-add" slot="start" />
            <ion-label>{{ 'left_menu_signup' | uvetranslate }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      }

      @if (isAnonymous) {
        <ion-menu-toggle>
          <ion-item menuClose mode="md" tappable data-cy="login-item" (click)="logoutConfirmation()">
            <ion-icon name="person" slot="start" />
            <ion-label>{{ 'left_menu_login' | uvetranslate }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      }
    </ion-list>
  </ion-content>
  @if (showPowered) {
    <app-footer-menu />
  }
</ion-menu>
